import { render, staticRenderFns } from "./GenericAddressForm.vue?vue&type=template&id=2ab5756a&"
import script from "./GenericAddressForm.vue?vue&type=script&lang=js&"
export * from "./GenericAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports